const Experience = () => {
    return (
        <div className="experience">
            <h2>Interests and Activities</h2>

            <ul>
                <li>
                    <i>Learning Languages</i> 
                    <ul>
                        <li>Mandarin, native speaker</li>
                        <li>English, fluent</li>
                        <li>Cantonese, fluent</li>
                        <li>Japanese, basic</li>
                    </ul>
                </li>
                <li>
                    <i>Standup Comedy</i> 
                    <ul>
                        <li>Rookie Match Championship in GuangDong District</li>
                    </ul>
                </li>
                <li>
                    <i>Producing Music</i> 
                    <ul>
                        <li>Published 93 songs, in total 20 million views</li>
                    </ul>
                </li>
                <li>
                    <i>I own a video channel, where I teach web3 programming</i> 
                </li>
            </ul>
        </div>
    );
}

export default Experience;